import { debounce } from 'lodash-es';

export interface GeocodingResult {
  lat: number;
  lon: number;
  display_name: string;
  address: {
    city?: string;
    town?: string;
    state?: string;
    country?: string;
    postcode?: string;
    road?: string;
    house_number?: string;
  };
}

export const searchAddress = debounce(async (query: string): Promise<GeocodingResult[]> => {
  if (!query.trim()) return [];

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&addressdetails=1&limit=5`,
      {
        headers: {
          'Accept-Language': 'en-US,en;q=0.9',
          'User-Agent': 'Meet&Eat/1.0'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch address suggestions');
    }

    const results = await response.json();
    return Array.isArray(results) ? results : []; // Ensure we return an array
  } catch (error) {
    console.error('Error searching address:', error);
    return [];
  }
}, 300);

export const reverseGeocode = async (lat: number, lon: number): Promise<GeocodingResult | null> => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`,
      {
        headers: {
          'Accept-Language': 'en-US,en;q=0.9',
          'User-Agent': 'Meet&Eat/1.0'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to reverse geocode coordinates');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error reverse geocoding:', error);
    return null;
  }
};